import AddIcon from "components/ui/AddIcon";
import RemoveIcon from "components/ui/RemoveIcon";
import UploadImage from "components/ui/UploadImage";
import {
  MASTER_TENANT,
  PRODUCT,
  PRODUCT_CREATOR_PAGE,
} from "constants/commonConstants";
import {
  APPROVED_STATUS,
  brochureVariants,
  DRAFT_STATUS,
  PENDING_STATUS,
} from "constants/productConstants";
import { useApp } from "context/appContext";
import usePermissions from "hooks/usePermissions";
import { useSearchParams } from "react-router-dom";

export default function ProductBrochures({
  noOfImages,
  images,
  addImage,
  removeImage,
  info,
  imageUploadFailed = false,
  isEdit = false,
  handleBrochures,
  removeBrochureVariant = null,
  uploadSuccess,
}) {
  const { canRead, canUpdate, canAccess } = usePermissions();
  const { tenant, isProductApprovalEnabled } = useApp();
  const [searchParams] = useSearchParams();
  const fromPage = searchParams.get("from");
  const cannotEdit =
    isEdit &&
    (isProductApprovalEnabled && info.status && info.status !== APPROVED_STATUS
      ? fromPage !== "approver" &&
        (info.status === PENDING_STATUS ||
          (info.status === DRAFT_STATUS && !canAccess(PRODUCT_CREATOR_PAGE)))
      : (canRead(PRODUCT) && !canUpdate(PRODUCT)) || tenant === MASTER_TENANT);

  return (
    <div className="flex flex-col p-30 bg-white">
      <div className="grid grid-cols-5 pt-10 pb-20">
        <label className="font-bold text-14">Web variant</label>
        <label className="font-bold text-14">Mobile variant</label>
      </div>
      <div>
        {Object.keys(noOfImages)?.map((k, idx) => {
          return (
            <div key={k} className="grid grid-cols-5 gap-y-60 items-center">
              {brochureVariants.map(({ name, variant, accept }, i) => (
                <div key={i} className="flex flex-col gap-y-30 items-center">
                  <UploadImage
                    uploadImage={(file) =>
                      handleBrochures({ name, variant }, idx + 1, file)
                    }
                    info={info}
                    imageUploadFailed={imageUploadFailed}
                    disabled={cannotEdit}
                    variant={name}
                    images={images}
                    row={idx + 1}
                    removeImage={() => removeBrochureVariant(idx + 1, name)}
                    uploadSuccess={uploadSuccess}
                    accept={accept}
                  />
                </div>
              ))}
              <div className="flex justify-start gap-x-20 gap-y-30 pt-5">
                {Number(idx) === Object.keys(noOfImages).length - 1 && (
                  <AddIcon
                    onClick={() => {
                      !cannotEdit &&
                        addImage(
                          Number(
                            Object.keys(noOfImages)[
                              Object.keys(noOfImages).length - 1
                            ]
                          ) + 1
                        );
                    }}
                  />
                )}
                {Object.keys(noOfImages).length > 1 && (
                  <RemoveIcon onClick={() => !cannotEdit && removeImage(k)} />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
